import { https } from "../http";
import store from "../store";
import {
  setSkypointProviderLoading,
  setSkypointProviders,
} from "../store/reducers/skypointProvider";
import { getCookie, setCookie, showError } from "../utils/index";


const getAllSkypointProvider = async (page = "all", showLoading = true) => {
  try {
    const viewerToken = getCookie("skypoint_token");
    const strUrl = `/skypointProvider/${page}${
      viewerToken && Boolean(localStorage.getItem("isProviderView")) === true
        ? `?viewerToken=${viewerToken}`
        : ""
    }`;
    if (showLoading) store.dispatch(setSkypointProviderLoading(true));
    let response = await https().get(strUrl);
    if (response?.status === 200) {
      store.dispatch(setSkypointProviders(response?.data));
    }
  } catch (error) {
    store.dispatch(setSkypointProviderLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const generateProviderToken = async (payload, navigate) => {
  try {
    let response = await https().post(
      "/skypointProvider/generate-token",
      payload
    );
    if (response?.status === 200) {
      const { token } = response?.data;
      if (token) {
        setCookie(token, "token");
        localStorage.setItem("isProviderView", true);
        window.location.reload();
      }
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export { getAllSkypointProvider, generateProviderToken };
